<template>
<div class="container">
    <div class="d-flex justify-content-center h-100 p-4">
        <slot />
    </div>
</div>
</template>

<script>
export default {
    components: {},
    watch: {
        '$route'(newRoute) {
            this.showTitle();
        },
    },
    methods: {
        showTitle() {
            let suffix = this.$route.meta.suffix;
            if (suffix === undefined) {
                suffix = ''
            } else {
                suffix = ' ' + this.$t(suffix);
            }
            document.title = this.$t(this.$route.meta.title) + suffix;
        },
    },
    mounted() {
        this.showTitle();
    }
};
</script>



// WEBPACK FOOTER //
// src/layouts/central/AuthorizationLayout.vue